<template>
  <div class="devprofile container-fluid">
    <Navbar />
    <div class="mt-5">
      <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-8 px-md-5 bg-light">
          <div v-if="loading" class="my-5">
            <a-skeleton active avatar :paragraph="{ rows: 5 }" />
          </div>
          <div v-else>
            <Profile :talent="talent" />
          </div>
        </div>

        <div class="col-sm-12 col-md-12 col-lg-4 bg-light pt-5">
          <div style="position: sticky; top:85px;">
            <div
              class="bg-light p-4 border add-rounded shadow-sm mb-5 ml-3 mr-3"
            >
              <div class="bg-kovatek m-2 m-md-1 m-lg-3 p-4 add-rounded">
                <div class="row text-left">
                  <div class="col-8 text-white">
                    <h4 class="text-white text-size2">Skill Score</h4>
                  </div>
                  <div class="col-4 text-white">
                    <h4 class="text-white text-size2">65%</h4>
                  </div>
                </div>
                <div class="row text-left">
                  <div class="col-8 text-white">
                    <p class="text-size3">Profile</p>
                  </div>
                  <div class="col-4 text-white">
                    <p class="text-size3">19</p>
                  </div>
                </div>
                <div class="row text-left">
                  <div class="col-8 text-white">
                    <p class="text-size3">Sprint Project Exercise</p>
                  </div>
                  <div class="col-4 text-white">
                    <p class="text-size3">22</p>
                  </div>
                </div>
                <div class="row text-left">
                  <div class="col-8 text-white">
                    <p class="text-size3">Live Interview</p>
                  </div>
                  <div class="col-4 text-white">
                    <p class="text-size3">24</p>
                  </div>
                </div>

                <!-- <button class="see-more px-2 px-md-4 px-lg-5 py-2 mt-3">Learning Workspace</button>      -->
              </div>
            </div>

            <h4 class="font-weight-bold mt-4" style="font-size: 20px;">
              Connect with talents
            </h4>
            <form class="pb-4 m-auto cont-w">
              <input
                type="email"
                class="w-92 my-3 mx-auto form-control input-height"
                id="email"
                placeholder="Company's email address"
              />
              <input
                type="password"
                class="w-92 my-3 mx-auto form-control input-height"
                id="pwd"
                placeholder="Password"
              />
              <input
                type="password"
                class="w-92 my-3 mx-auto form-control input-height"
                id="email"
                placeholder="Confirm Password"
              />
              <br />
              <div class="m-auto">
                <router-link to="#">
                  <button
                    class="btn btn-kovatek submit-w mb-4"
                    style="font-size: 13px"
                  >
                    Register
                  </button>
                </router-link>
                <p style="font-size: 13px">
                  Already have an account?
                  <router-link to="#">Login</router-link>
                  <!-- <router-link to="/hire">
                  <button class="btn btn-kovatek submit-w mb-4" style="font-size: 13px">Register</button>
                </router-link>
                <p style="font-size: 13px">
                  Already have an account?
                  <router-link to="/login">Login</router-link>-->
                </p>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import Footer from "@/components/Footer.vue";
import Profile from "@/components/Profile.vue";

export default {
  name: "devprofile",
  components: {
    Profile,
    Navbar,
    Footer,
  },
  data() {
    return {
      loading: false,
      talent: null,
      error: null,
    };
  },
  mounted() {
    this.loading = true;
    const param = {
      userID: this.$route.query.id,
    };
    this.$store
      .dispatch("profiles/getTalentProfile", param)
      .then((resp) => {
        this.talent = resp.data;
        this.loading = false;
      })
      .catch((err) => {
        this.error = err.message;
        this.loading = false;
      });
  },
};
</script>

<style scoped>
.btn-kovatek {
  background-color: #20409a;
  height: 50px;
  color: #fff;
  transition: 0.25s;
}
.btn-kovatek:hover {
  background-color: #06216d;
  color: #fff;
}
.input-height {
  height: 50px;
  font-size: 13px;
  width: 100%;
}
.submit-w {
  width: 404px;
}
@media screen and (min-width: 992px) and (max-width: 1325px) {
  .cont-size {
    width: 600px;
  }
}

@media screen and (min-width: 768px) and (max-width: 991px) {
  .cont-size {
    width: 600px;
  }
}

@media screen and (max-width: 767px) {
  .cont-size {
    width: 500px;
  }
}

@media screen and (max-width: 450px) {
  .cont-size {
    width: 100%;
  }
}

.bg-kovatek {
  background-color: #20409a;
}
.btn-kovatek {
  background-color: #20409a;
  height: 50px;
  color: #fff;
  transition: 0.25s;
}
.btn-kovatek:hover {
  background-color: #06216d;
  color: #fff;
}
.input-height {
  height: 50px;
  font-size: 13px;
  width: 100%;
}

.add-rounded {
  border-radius: 20px;
}
.img-height {
  width: 160px;
  height: 160px;
}
.text-intermediate {
  color: #bdbd50;
}
.text-size {
  font-size: 16px;
}
.text-size1 {
  font-size: 20px;
}
.text-size2 {
  font-size: 16px;
}
.text-size3 {
  font-size: 13px;
}
.see-more {
  background-color: transparent;
  border: solid 1.5px #fff;
  border-radius: 20px;
  color: #fff;
  transition: 0.25s;
}
.see-more:hover {
  background-color: #fff;
  color: #20409a;
}
.rating {
  color: #4bb38e;
}
.star {
  position: relative;
  bottom: 10px;
  height: 25px;
}
@media screen and (min-width: 992px) and (max-width: 1325px) {
  .cont-size {
    width: 600px;
  }
  .img-height {
    width: 120px;
    height: 120px;
  }
}

@media screen and (min-width: 768px) and (max-width: 991px) {
  .cont-size {
    width: 600px;
  }
  .img-height {
    width: 120px;
    height: 120px;
  }
}

@media screen and (max-width: 767px) {
  .img-height {
    width: 115px;
    height: 115px;
  }
  .text-size {
    font-size: 16px;
  }
  .text-size2 {
    font-size: 16px;
  }
  .ctrl-heading {
    font-size: 13px;
  }
  .ctrl-heading1 {
    font-size: 13px;
  }
  .ctrl-heading2 {
    font-size: 13px;
  }
  .star {
    position: relative;
    bottom: 5px;
    height: 18px;
  }
}

.w-92 {
  width: 90% !important;
}

@media screen and (max-width: 450px) {
  .cont-size {
    width: 100%;
  }

  .text-size2 {
    font-size: 13px;
  }
  .img-height {
    width: 85px;
    height: 85px;
  }

  .submit-w {
    width: 300px !important;
  }
}
</style>
